import { Component, Input } from '@angular/core';

@Component({
  selector: 'alert-container',
  templateUrl: 'alert-container.html'
})
export class AlertContainerComponent {
  @Input() alertText: string;
  @Input() alertTextArray: string[];

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/pages/shared/components/alert-container/alert-container.ts